
// region JS Imports

// region External Modules
import on_domready from "domready"
// endregion External Modules

// region Private Modules
import {
  Factory as PaginationFactory,
  Pagination,
} from "app/pagination"
import StickyNavbarHandler from "app/sticky_navbar_handler/index"

import DataRetriever from "app/data_retriever"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import ImageLazyLoading from "widgets/image_lazyloading"
import BackgroundImageLazyloading from "widgets/background_image_lazyloading"
// endregion Private Modules

// region Public Components
import {
  Factory as FilterBarDesktop,
} from "concepts/serviced_apartment_buildings/searches/filter_bar/desktop/index"

import {
  init as ColivingSpaceEntryBox,
} from "apps/spacious_website/components/coliving_spaces/entry_box"

import ServicedApartmentBuildingRow from "concepts/serviced_apartment_buildings/row"

import PageVisitCount from "pages/cities/serviced_apartments/components/page_visit_count"
// endregion Public Components

// region Private Components
import {
  Factory as Sidebar,
} from "./../components/sidebar/index"
import BuildingList from "./../components/building_list/index"

import {
  Factory as Map,
} from "./components/map/index"

import {
  load_and_inject_content as load_and_inject_below_the_fold_section,
} from "./below_the_fold_section"
// endregion Private Components

// endregion JS Imports


const init = () => {
  const body_el = document.querySelector("body") as HTMLElement

  PageVisitCount.incrementValue()

  const paginate_instance = PaginationFactory.create()

  ServicedApartmentBuildingRow.init()
  ColivingSpaceEntryBox()
  init_pagination(paginate_instance)


  on_domready(() => {
    const city_id = DataRetriever.get("city-id")
    const serviced_apartments_filter = FilterBarDesktop.instance()

    if (serviced_apartments_filter) {
      serviced_apartments_filter.on("DATA_ABOUT_TO_LOAD", () => {
        BuildingList.showAsLoading(true)
      })
      serviced_apartments_filter.on("DATA_LOADED", (data: string) => {
        BuildingList.updateContent(data)
        ImageLazyLoading.default_lazyload_instance().update()
        BuildingList.showAsLoading(false)
        init_pagination(paginate_instance)
        ServicedApartmentBuildingRow.init()
        ColivingSpaceEntryBox()
      })
    }

    load_and_inject_below_the_fold_section(city_id)
    .then(() => {
      body_el.classList.add("page--below-the-fold-content-loaded")

      Sidebar.create()
      ImageLazyLoading.default_lazyload_instance().update()
      BackgroundImageLazyloading.default_lazyload_instance().update()

      WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        Map.create()
      })
    })
  })
}

function init_pagination(paginate_instance: Pagination) {
  paginate_instance.init(BuildingList.getContainer())
  paginate_instance.onUpdate(() => {
    StickyNavbarHandler.scrollTo(BuildingList.getContainer(), {duration: 1000})
    FilterBarDesktop.instance().update({page: paginate_instance.getPage()})
  })
  paginate_instance.initEvent()
}

export default {
  init,
}
